import { Component, OnChanges, SimpleChanges, ViewChild, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { CoursModel } from '../../cours/models/cours.model';
import { FormGroup } from '@angular/forms';
import { EleveRechercheModel } from '../../eleve/models/eleve-recherche.model';
import { EleveModel } from '../../eleve/models/eleve.model';
import { SettingsService } from '../../core/settings/settings.service';
import { ToasterService } from 'angular2-toaster';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormGeneratorService, StoreService } from '@ngx-resource-toolkit/core';
import { TabsService } from '../services/tabs.service';
import { InscriptionModel } from '../inscriptions/inscription.model';
import { FormArray } from '@angular/forms/src/model';
import { inscriptionActionFetchOptions } from '../resource/select-options';
import { isOneOfSelectOptionsNull, SelectActions } from '../resource/select.store';
import { CoursService } from '../services/cours.service';

import 'rxjs/add/operator/combineLatest';
import { Subscription } from 'rxjs/Subscription';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'cours-form',
    templateUrl: './cours.component.html',
})
export class CoursFormComponent implements OnInit {

    @Input() cours: CoursModel;
    @Input() isModal: boolean = false;
    @Input() public form: FormGroup;
    @Input() public mode: string;
    // public formsInscriptions: FormArray;

    public eleveSearchModel: EleveRechercheModel;
    public eleveSearchForm: FormGroup;
    // TODO à remplacer par inscriptionList
    public eleveList: EleveModel[]; // Liste des élèves issus de la recherche élève

    public inscriptionModel: InscriptionModel;
    public eleveModel: EleveModel;
    // public inscriptions: InscriptionModel[];
    // public eleves: EleveModel[]; // utiliser cours.inscriptions à la place

    @ViewChild('modal') modal: any;
    @Output() save: EventEmitter<any> = new EventEmitter<any>();
    @Output() update: EventEmitter<any> = new EventEmitter<any>();
    @Output() cancel: EventEmitter<any> = new EventEmitter<any>();

    codeActionOptions = [];

    subscription: Subscription;

    constructor(
            private toaster: ToasterService,
            private http: HttpClient,
            private store: StoreService,
            private settings: SettingsService,
            private coursService: CoursService,
            private formGenerator: FormGeneratorService,
            public datepipe: DatePipe) {

        this.eleveSearchModel = new EleveRechercheModel();
        this.eleveSearchForm = this.formGenerator.createFormGroup(this.eleveSearchModel, 'search');

        this.eleveModel = new EleveModel({});
        this.inscriptionModel = new InscriptionModel({});
        // this.eleveInscris = [];

    }

    reset() {
        // console.log({ where: 'reset', inscriptions: this.cours.inscriptions})
        this.form.reset();
        this.cours.inscriptions = this.cours.inscriptions.filter(ins=>ins.id); // Pour supprimer les nouvelles inscriptions 
        this.initForm();
    }
    initForm() {
        this.form.setControl(
            'inscriptions',
            this.formGenerator.createFormGroup(this.cours.inscriptions, 'tableCours'));
    }
    ngOnInit(): void {
        // console.log({ ou: 'CoursFormComponent.form', form: this.form, mode: this.mode, inscriptions: this.cours.inscriptions} );

        const mode = 'tableCours';
        if (!!this.form) {
            this.initForm();
        }

        if (!!this.cours) {
            // Alimentation de la liste déroulante de la colonne Etat
            const anneeScolaire = this.settings.getUserSetting('anneeScolaire');

            this.subscription = this.http.get(
                inscriptionActionFetchOptions.url,
                {params: {'params': JSON.stringify(['ref_inscription_action', anneeScolaire]), }}
            )
            .combineLatest(
                this.store.getState((state) => state.selectOptions)
                .do(selectOptions => {
                    if (isOneOfSelectOptionsNull(selectOptions) && !selectOptions.loading) {
                        this.store.dispatch(
                            SelectActions.fetch({
                                http: this.http,
                            })
                        );
                    }
                })
                .filter(selectOptions => !isOneOfSelectOptionsNull(selectOptions))
            )
            .subscribe(([inscriptionAction, selectOptions]) => {
                const options = inscriptionActionFetchOptions.resMapper(inscriptionAction);

                this.cours.registerEntriesDynamicProperties(['edit'], this.coursService.getSelectOptions(selectOptions));

                this.inscriptionModel.registerEntriesDynamicProperties([mode],
                    {
                        codeAction: { options: [{value: null, label: '' }, ...options] }
                    }
                );

                this.codeActionOptions = [...options];
            });
            this.inscriptionModel.registerEntryDynamicProperty([mode], 'codeAction', 'onChanges', (value, form) => {
                console.log('codeAction onChanges', value, form);
            });

            // Attention : voir les différents cas : cours individuel, on a certainement renseigné le champ eleve
            // alors que pour les cours collectifs on doit utiliser cours.inscriptions
            /*if (this.cours && this.cours.eleve) {
                this.eleves = [this.cours.eleve];
            }*/
            /*if (this.cours && this.cours.inscriptions) {
                this.inscriptions = this.cours.inscriptions;
            }*/
        }
    }



    searchEleve() {

        this.eleveSearchModel.getResource('default', 'find').call(this.http, this.eleveSearchForm, []).subscribe(
            (data) => {
                this.eleveList = [];

                if (data instanceof Array) {
                    data.forEach((eleve) => {
                        this.eleveList.push(new EleveModel(eleve));
                    });
                }
            }, (err) => {
                console.log('CoursFormComponent', 'search error', err);
                this.toaster.pop('error', 'Erreur lors de la recherche d\'élèves');
            }
        );

    }

    selectEleve(event) {
        const eleveAAjouter = new EleveModel(event[0]);
        const eleveDejaPresent = this.cours.inscriptions.find( i => 
            +i.eleve.id == +eleveAAjouter.id
        );
        if (eleveDejaPresent) {
            this.toaster.pop('error', "L'élève est déjà présent dans le cours.");
            return;
        }
        const inscriptionSelectionnee = new InscriptionModel(
            event.length ? {
                eleve: eleveAAjouter,
                eleveid: eleveAAjouter.id,
                anneeScolaire: this.settings.getUserSetting('anneeScolaire'),
            } : {}
        );
        // console.log('inscriptionSelectionnee=', inscriptionSelectionnee);
        this.cours.inscriptions = [...this.cours.inscriptions ? this.cours.inscriptions : [], inscriptionSelectionnee];
        this.initForm();
        this.modal.close();
    }

    deselectInscription(event) {
        this.cours.inscriptions = [...this.cours.inscriptions.filter((inscription) => {
            // 2 cas : inscription.id si inscription existe deja en BDD, inscription.eleveid si l inscription vient d etre creee
            return inscription.id ? inscription.id !== event.row.id : inscription.eleveid !== event.row.eleve.id;
        })];
    }

    onCellSave({row, rowIndex, column}) {
        console.log({row, rowIndex, column});
        this.cours.inscriptions = [...this.cours.inscriptions.map(inscription => {
            console.log({ inscription });
            if ((row.id && row.id === inscription.id) || (!row.id && row.eleve.id === inscription.eleveid)) {
                switch (column.prop) {
                    case 'codeAction': {
                        inscription.codeAction = row.codeAction;
                        const action = this.codeActionOptions.find(option => option.value === row.codeAction);
                        inscription.libelle_action = action && action.label ? action.label : '';
                        break;
                    }
                    case 'dateDebut': {
                        inscription.dateDebut = this.datepipe.transform(row.dateDebut, 'yyyy-MM-dd'); // row.dateDebut;
                        break;
                    }
                    case 'dateFin': {
                        inscription.dateFin = this.datepipe.transform(row.dateFin, 'yyyy-MM-dd'); // row.dateFin;
                        break;
                    }
                    case 'nbAnneeDansCycle': {
                        inscription.nbAnneeDansCycle = row.nbAnneeDansCycle;
                    }
                }
            }
            return inscription;
        })];
    }

    public updateCours() {
        this.update.emit();
    }
    public saveCours() {
        this.save.emit();
    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/cours/cours.component.ts